import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/lib/LangContext";

export default function EditorialMarquee() {
  const { t } = useLang();
  const line = t.marquee_line;
  return (
    <section aria-hidden className="relative py-8 lg:py-14 overflow-hidden border-y border-white/5" data-testid="editorial-marquee">
      <Marquee gradient={false} speed={22} pauseOnHover={false} play>
        <span className="font-display font-black text-[14vw] lg:text-[10vw] leading-none tracking-[-0.045em] text-stroke pr-16 whitespace-nowrap">
          {line}
        </span>
        <span className="font-display font-black text-[14vw] lg:text-[10vw] leading-none tracking-[-0.045em] text-red-500/90 pr-16 whitespace-nowrap">
          {line}
        </span>
      </Marquee>
    </section>
  );
}
